var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebinar56 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 56,
  height: 56,
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29 43.5C29 43.2239 28.7761 43 28.5 43C28.2239 43 28 43.2239 28 43.5V47H16.5C16.2239 47 16 47.2239 16 47.5C16 47.7761 16.2239 48 16.5 48H28.5H40.5C40.7761 48 41 47.7761 41 47.5C41 47.2239 40.7761 47 40.5 47H29V43.5Z",
  fill: "var(--icon-decorative-coral)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 9.5C6 9.22386 6.22386 9 6.5 9H50.5C50.7761 9 51 9.22386 51 9.5V38.5C51 38.7761 50.7761 39 50.5 39H6.5C6.22386 39 6 38.7761 6 38.5V9.5ZM7 10V38H50V10H7Z",
  fill: "currentColor"
})));
export default SvgWebinar56;